module.exports = __webpack_public_path__ + "img/glamBubble2.d85f1381.jpg";